export const CollectionsDashboardRoute = {
  path: '/dashboard/collections',
  load: () => import('./CollectionsDashboard'),
  protected: true,
};

export const CollectionDetailsRoute = {
  path: '/accounting/collectionsByCustomer/:id',
  load: () => import('./components'),
  protected: true,
};
